import Balconi from "../Common/icons/Balconi";
import Bed from "../Common/icons/Bed";
import Broom from "../Common/icons/Broom";
import BusinessCenter from "../Common/icons/BusinessCenter";
import Chair from "../Common/icons/Chair";
import Checks from "../Common/icons/Checks";
import CheckTag from "../Common/icons/CheckTag";
import Deck from "../Common/icons/Deck";
import Disabled from "../Common/icons/Disabled";
import Elevator from "../Common/icons/Elevator";
import Food from "../Common/icons/Food";
import Forest from "../Common/icons/Forest";
import Gym from "../Common/icons/Gym";
import Internet from "../Common/icons/Internet";
import Kitchen from "../Common/icons/Kitchen";
import Languages from "../Common/icons/Languages";
import NoSmoke from "../Common/icons/NoSmoke";
import Parking from "../Common/icons/Parking";
import Pool from "../Common/icons/Pool";
import Reception from "../Common/icons/Reception";
import Sauna from "../Common/icons/Sauna";
import Security from "../Common/icons/Security";
import Shop from "../Common/icons/Shop";
import Shower from "../Common/icons/Shower";
import Taxi from "../Common/icons/Taxi";
import Tennis from "../Common/icons/Tennis";
import Tv from "../Common/icons/Tv";
import View from "../Common/icons/View";

const AccommodationFacilityIcon = props => {

    const className = "facility-icon";

    switch (props.keyword) {
        case "accessibility":
            return (
                <CheckTag className={className} />
            );
        case "bathroom":
            return (
                <Shower className={className} />
            );
        case "bedroom":
        case "room-amenities":
        case "room-features":
        case "room-service":
            return (
                <Bed className={className} />
            );
        case "business-facilities":
            return (
                <BusinessCenter className={className} />
            );
        case "cleaning-services":
            return (
                <Broom className={className} />
            );
        case "common-areas":
            return (
                <Deck className={className} />
            );
        case "food-drink":
        case "restaurant":
            return (
                <Food className={className} />
            )
        case "internet":
            return (
                <Internet className={className} />
            )
        case 'languages-spoken':
            return (
                <Languages className={className} />
            );
        case "safety-security":
            return (
                <Security className={className} />
            );
        case "kitchen":
            return (
                <Kitchen className={className} />
            );
        case "living-area":
            return (
                <Chair className={className} />
            );
        case "media-technology":
            return (
                <Tv className={className} />
            );
        case "swimming-pool":
            return (
                <Pool className={className} />
            );
        case "wellness":
            return (
                <Gym className={className} />
            );
        case "transport":
            return (
                <Taxi className={className} />
            );
        case "shops":
            return (
                <Shop className={className} />
            );
        case "miscellaneous":
            return (
                <Checks className={className} />
            );
        case "outdoor-view":
            return (
                <Forest className={className} />
            );
        case "reception-services":
            return (
                <Reception className={className} />
            );
        case "balcony":
            return (
                <Balconi className={className} />
            );
        case "lift":
            return (
                <Elevator className={className} />
            );
        case "non-smoking":
            return (
                <NoSmoke className={className} />
            );
        case "sauna":
            return (
                <Sauna className={className} />
            );
        case "tennis-court":
            return (
                <Tennis className={className} />
            );
        case "parking":
            return (
                <Parking className={className} />
            );
        case "view":
            return (
                <View className={className} />
            );
        case "disabled":
            return (
                <Disabled className={className} />
            )

    }

    return (
        <CheckTag className={className} />
    )
}

export default AccommodationFacilityIcon;